// CERENZA — Imágenes principales del sitio (IA-generadas + foto real para Generaciones)
// Las fotos reales viven en /app/frontend/src/lib/diaries.js (Diario Visual)

const BASE = "https://static.prod-images.emergentagent.com/jobs/56cef67e-da37-45b9-86ed-3461fcd5b333/images";
const ARCE_FAMILY = "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/eef2bxgk_Familia%20Arce%20%20Redes%20Sociales-%20RalvasaStudio_6.jpg";

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/nd5y1shb_ana%20pug.png",
  experience: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/40chrk4k_Ana%20embarazo%20Andr%C3%A9s%20-%20Redes%20sociales-21.jpg",
  finalCta: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/75mir8ny_Ana%20embarazo%20Andr%C3%A9s%20-%20Redes%20sociales-51.jpg",
  // Polaroids order: [Michelle (back), Capuchino (middle), Antonella (front))]
  polaroids: [
    "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/5j8rmkd0_Michelle-19.JPG",
    "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/s7428dp7_Capuchino1.jpeg",
    "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/o21nqtyi_Antonella%201%20a%C3%B1o%201.png",
  ],
  aboutMe: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/j4k7334j_ChatGPT%20Image%2014%20may%202026%2C%2006_23_00%20p.m..png",
  sessions: [
    { id: "familia", title: "Familia", subtitle: "Celebramos lo que los une.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/75mir8ny_Ana%20embarazo%20Andr%C3%A9s%20-%20Redes%20sociales-51.jpg", fit: "contain" },
    { id: "maternidad", title: "Maternidad", subtitle: "La espera también es parte de la magia.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/kgg47qnv_Ana%20embarazo%20Andr%C3%A9s%20-%20Redes%20sociales-38.jpg", fit: "contain" },
    { id: "bebes", title: "Bebés", subtitle: "Sus primeros días, para siempre.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/gcju0703_Antonella%201%20a%C3%B1o%201.png", fit: "contain" },
    { id: "generaciones", title: "Generaciones", subtitle: "Para mamás que ya los vieron crecer.",
      url: ARCE_FAMILY, fit: "contain" },
    { id: "graduaciones", title: "Graduaciones", subtitle: "El brindis a una etapa que se cierra con orgullo.",
      url: "/generated/graduaciones_0.png", fit: "contain" },
    { id: "mascotas", title: "Mascotas", subtitle: "Ellos también son parte de la familia.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/3s6r84vl_Capuchino7.jpeg", fit: "contain" },
    { id: "personalizada", title: "Experiencias Personalizadas", subtitle: "Ideas únicas para historias como la tuya.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/3puv0r2i_WhatsApp%20Image%202026-05-14%20at%205.19.02%20PM%20%284%29.jpeg", fit: "contain" },
    { id: "parejas", title: "Parejas", subtitle: "El amor también merece su capítulo.",
      url: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/1slbpoho_Danna%20y%20Mat%C3%ADas.jpeg", fit: "contain" },
  ],
};

export const EXPERIENCE_VALUES = [
  { value: "familia", label: "Familia" },
  { value: "maternidad", label: "Maternidad" },
  { value: "bebes", label: "Bebés" },
  { value: "generaciones", label: "Generaciones" },
  { value: "graduaciones", label: "Graduaciones" },
  { value: "parejas", label: "Parejas" },
  { value: "mascotas", label: "Mascotas" },
  { value: "personalizada", label: "Experiencia Personalizada" },
];

export const STATUS_LABEL = {
  new: "Nueva",
  contacted: "Contactada",
  confirmed: "Confirmada",
  archived: "Archivada",
};
